import _util from '../../utils/';

const crewRosteringListService = {
	fetchCrewRosteringList(gets, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceManagements/Get',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	fetchCrewRosteringDetail(gets, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceManagements/Details',
			params: gets,
			success: resolve,
			error: reject
		})
	},
	updateCrewRostering(puts, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceManagements/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		});		
	},
	updateSchedule(puts, resolve, reject) {
		_util.request({
			url: '/api/HRAttendanceAdjustSchedule/Put',
			method: 'put',
			data: puts,
			success: resolve,
			error: reject
		});		
	},
    exportCrewRostering(gets, resolve, reject) {
        _util.request({
            url: '/api/HRAttendanceManagements/Export',
            params: gets,
			// data: data,
            success: resolve,
            error: reject
        })
    }
}

export default crewRosteringListService;


// WEBPACK FOOTER //
// ./src/services/Attendance/crew-rostering-service.js